import PropTypes from 'prop-types';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import MyDialog from '../../components/dialog-component/my-dialog';
import { openModal } from '../../redux/slices/authUiSlice';
import useLocales from '../../hooks/useLocales';

const ForgotPassword = ({ handleClose, handleOpen }) => {
  const { translate } = useLocales();
  const dispatch = useDispatch();


  // useEffect(() => {
  //   loadCaptchaEnginge(4);
  // }, []);

  // const isValidMobile = () => {
  //   const _errors = {};
  //   let valid = true;

  //   const fullPhone = `${countryCode}${phone}`.replace(/[^0-9+]/g, '');

  //   const invalidPhoneNumber = validatePhoneNumber(fullPhone);

  //   if (!phone?.trim()) {
  //     valid = false;
  //     _errors.phone = 'Phone number is required';
  //   } else if (invalidPhoneNumber) {
  //     valid = false;
  //     _errors.phone = invalidPhoneNumber;
  //   }

  //   if (validateCaptcha(captcha?.trim()) === false) {
  //     valid = false;
  //     _errors.captcha = 'Captcha not match';
  //     setCaptcha('');
  //   }

  //   setFormError(_errors);
  //   return valid;
  // };

  // const onSubmitMobile = async () => {
  //   try {
  //     setError('');
  //     setIsLoading(true);

  //     const fullPhone = `${countryCode}${phone}`.replace(/[^0-9]/g, '');

  //     if (!isValidMobile()) return;

  //     const isExists = await checkIfNumberExist(fullPhone);

  //     if (!isExists) {
  //       throw new Error('Number not exists');
  //     }

  //     let fingerprint = localStorage.getItem('fingerprint');

  //     if (!fingerprint) {
  //       fingerprint = uuidv4();
  //       localStorage.setItem('fingerprint', fingerprint);
  //     }

  //     const response = await conObj.post('otp_request.json', {
  //       no_hp: fullPhone,
  //       fingerprint,
  //       purpose: 'forgotpassword',
  //     });

  //     navigate('/auth/reset-password', {
  //       state: {
  //         otpUuid: response.data?.data?.data?.otp_uuid,
  //         phoneNumber: fullPhone,
  //       },
  //     });
  //   } catch (err) {
  //     console.error(err);
  //     setError(getOtpErrorMessage(err));
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <MyDialog open={handleOpen} close={handleClose} maxSize={'sm'} title={translate('forgot_password')}>
      <Box>
        <Typography sx={{ textAlign: 'center', color: '#666', cursor: 'pointer' }}>
          {translate('agent_step3_2')}
        </Typography>
      </Box>
      {/* Segmented Control */}
      {/* <SegmentContainer sx={{ mb: 4 }}>
        {tabs.map((item, i) => (
          <SegmentButton
            key={i}
            active={tab === i ? 1 : 0}
            onClick={() => setTab(i)}
            sx={{
              borderRadius: '999px',
            }}
          >
            <Iconify icon={item.icon} width={18} />
            {item.label}
          </SegmentButton>
        ))}
      </SegmentContainer> */}

      {/* <InputField
        placeholder={translate('username')}
        icon="mdi:account-outline"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      /> */}

      {/* {tab === 1 && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField
            select
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            sx={{
              width: 130,
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                backgroundColor: '#f5f5f5',
                color: '#000000',
              },
            }}
            SelectProps={{
              renderValue: (selected) => {
                const country = countries.find((c) => c.code === selected);
                return (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <img src={country?.flag} alt="" style={{ width: 22, height: 16, borderRadius: 3 }} />
                    {selected}
                  </Box>
                );
              },
              MenuProps: {
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: {
                  sx: {
                    borderRadius: '10px',
                    minWidth: 200,
                    backgroundColor: '#fff',
                    color: '#000',

                    '& .MuiMenu-list': {
                      paddingTop: 0,
                      paddingBottom: 0,
                    },
                  },
                },
              },
            }}
          >
            {countries.map((c) => (
              <MenuItem
                key={c.code}
                value={c.code}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  py: 0.5,
                  minHeight: 'unset',
                  height: 36,

                  '&.Mui-selected': {
                    background: 'linear-gradient(90deg, #f7c873, #e6a23c)',
                    color: '#000000',
                  },

                  '&.Mui-selected:hover': {
                    background: 'linear-gradient(90deg, #f7c873, #e6a23c)',
                  },

                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
              >
                <img
                  src={c.flag}
                  alt=""
                  style={{
                    width: 24,
                    height: 16,
                    borderRadius: 3,
                    objectFit: 'cover',
                  }}
                />

                <Typography fontSize={14}>{c.label}</Typography>

                <Typography fontSize={14} sx={{ marginLeft: 'auto', color: '#333' }}>
                  {c.code}
                </Typography>
              </MenuItem>
            ))}
          </TextField>

          <InputField fullWidth placeholder="0XXXXXXXXX" value={phone} onChange={(e) => setPhone(e.target.value)} />
        </Box>
      )} */}

      <Box
        sx={{ textAlign: 'right', mb: 2, mt: 2 }}
        onClick={() => {
          dispatch(
            openModal({
              view: 'login',
            })
          );
        }}
      >
        <Typography variant="body2" sx={{ textAlign: 'center', color: '#666', cursor: 'pointer' }}>
          {translate('or_return_to_login')}
        </Typography>
      </Box>

      {/* <GradientButton fullWidth disabled={!username && !password}>
        {translate('next')}
      </GradientButton> */}
    </MyDialog>
  );
};

ForgotPassword.propTypes = {
  handleClose: PropTypes.func,
  handleOpen: PropTypes.func,
};

export default ForgotPassword;
